import {INavLink} from "data/types/routing";
import {Language} from "data/enums";
import {GAME_ZONE_URL} from "./routing";

export const subMenuRouting: INavLink[] = [
	{
		title: "sub_header.links.picks",
		href: "/my-picks",
	},
	{
		title: "sub_header.links.rankings",
		href: "/rankings",
		isPrivate: true,
	},
	{
		title: "sub_header.links.leagues",
		href: "/leagues",
		isPrivate: true,
		urls: [
			{
				title: "sub_header.links.my_leagues",
				href: "/leagues",
			},
			{
				title: "sub_header.links.create_league",
				href: "/leagues/create",
			},
			{
				title: "sub_header.links.join",
				href: "/leagues/join",
			},
		],
	},
	{
		title: "sub_header.links.prizes",
		href: "/prizes",
	},
	{
		title: "sub_header.links.help",
		href: "/help",
	},
	{
		title: "sub_header.links.profile",
		href: `${GAME_ZONE_URL}profile`,
		isPrivate: true,
		isExternal: true,
	},
];

export const SelectProjectTitle = "sub_header.projects.pickem";

export const subMenuProjectLinksEn = [
	{
		title: "sub_header.projects.gz",
		href: GAME_ZONE_URL,
	},
	{
		title: "sub_header.projects.fantasy",
		href: GAME_ZONE_URL + "fantasy/",
	},
	{
		title: "sub_header.projects.blitzpicks",
		href: GAME_ZONE_URL + "blitzpicks/",
	},
	{
		title: "sub_header.title.futures",
		href: GAME_ZONE_URL + "futures/",
	},
	{
		title: "sub_header.title.team_picker",
		href: GAME_ZONE_URL + "teampicker/",
	},
	{
		title: "sub_header.title.all_star",
		href: GAME_ZONE_URL + "allstar/",
	},
];

export const subMenuProjectLinksFr = [
	{
		title: "sub_header.projects.gz",
		href: GAME_ZONE_URL,
	},
	{
		title: "sub_header.projects.fantasy",
		href: GAME_ZONE_URL + "fantasy/",
	},
	{
		title: "sub_header.projects.blitzpicks",
		href: GAME_ZONE_URL + "blitzpredictions/",
	},
	{
		title: "sub_header.title.futures",
		href: GAME_ZONE_URL + "futures/",
	},
	{
		title: "sub_header.title.team_picker",
		href: GAME_ZONE_URL + "selectionneurequipe/",
	},
	{
		title: "sub_header.title.all_star",
		href: GAME_ZONE_URL + "etoiles/",
	},
];

export const subMenuProjectLinks = {
	[Language.English]: subMenuProjectLinksEn,
	[Language.French]: subMenuProjectLinksFr,
};
